export type UserInput = {
  id: number;
  name: string;
  phone: string;
};

export class User {
  public id?: number;
  public name?: string;
  public phone?: string;

  constructor(user?: UserInput) {
    this.id = user?.id || undefined;
    this.name = user?.name || undefined;
    this.phone = user?.phone || undefined;
  }
}
